export const auth_user_gender_en = {
  m: 'Male',
  f: 'Female',
};
